export const HEADER_DETAILS = {
  chapterCode: '8',
  section:
    'Processing Requests for Property Tax Refund, Abatement, Payment Agreement, Deferral, Credit and Exemption.',
  sectionCode: '2',
  titleCode: '21',
};

export const SUBSECTION = {
  context: `Unless otherwise provided for herein, all requests for refund, abatement, payment
  agreement, deferral, credit or exemption of property taxes, and related penalties or
  interest, under Sections 59-2-1104 through 1109, 59-2-1115, 59-2-1321 and 59-2-1347,
  59-2-1201 through 59-2-1220 Utah Code Annotated, 1953 as amended, shall be by written
  application, shall set forth the specific basis for the request, and shall include all
  evidence supporting the request. A decision shall be made on each request based upon
  the submitted materials, unless the Board of County Commissioners desires further
  input from the applicant and takes action in a public meeting to place the matter on
  the commission agenda for further review.`,
};
